import axios from 'App/axios';
import { StoreCategoryResponse } from '../types/StoreCategoryResponse';

const getStoreCategory = async (): Promise<StoreCategoryResponse> => {
  try {
    const { data } = await axios.get(
      'v1/pago-nube-onboarding/kyc/recipients/categories',
    );

    return data;
  } catch (error) {
    throw new Error(
      `Failed to fetch store categories: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

export default { getStoreCategory };
